import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { HomeContainerComponent } from './containers/home-container/home-container.component';
import { HomeUiModule } from '@purplefront/home/ui';

export const homeFeatureShellRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeContainerComponent
  }
];

@NgModule({
  imports: [CommonModule, HomeUiModule, RouterModule.forChild(homeFeatureShellRoutes)],
  declarations: [HomeContainerComponent],
  exports: [HomeContainerComponent]
})
export class HomeFeatureShellModule {}
